import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
export default {
  mixins: [serchSelect],
  props: {
    languageLists: {
      type: Array
    }
  },
  data: function data() {
    var _form;

    return {
      form: (_form = {
        state: '',
        show_name: '',
        game_name: '',
        language: [],
        params: [],
        game_type: '',
        appid: '',
        appsecret: '',
        extend: []
      }, _defineProperty(_form, "state", ''), _defineProperty(_form, "login_type_list", []), _form),
      copyform: {},
      picfileList: [],
      paramsMark: {
        language: '',
        picfileList: [],
        icon: '',
        game_name: '',
        languageName: ''
      },
      dialogShow: false,
      rules: {
        icon: [{
          required: true,
          message: "请上传",
          trigger: "blur"
        }],
        show_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        game_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        game_type: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        appsecret: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.copyform = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    init: function init(datas) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, lang, list, extendList, extend, key, loginlist, loginArr;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  data.language = data.language ? data.language.split(',') : [];
                  lang = data.language;
                  list = [];
                  lang.forEach(function (i) {
                    list.push(data.params.findIndex(function (j) {
                      return j.language == i;
                    }) > -1 ? _objectSpread(_objectSpread({}, data.params.find(function (j) {
                      return j.language == i;
                    })), {}, {
                      picfileList: ''
                    }) : _objectSpread(_objectSpread({}, _this.paramsMark), {}, {
                      language: i,
                      languageName: _this.languageList.find(function (j) {
                        return j.sign == i;
                      }).name,
                      picfileList: ''
                    }));
                  });
                  extendList = data.extend ? data.extend : {};
                  extend = [];

                  for (key in extendList) {
                    extend.push({
                      label: key,
                      value: extendList[key]
                    });
                  }

                  data.extend = extend;
                  loginlist = data.login_type_list ? data.login_type_list.split(",") : [];
                  console.log("loginlist===", loginlist);
                  loginArr = [];
                  loginlist.forEach(function (item) {
                    loginArr.push({
                      value: item
                    });
                  });
                  data.login_type_list = loginArr;
                  data.params = list;
                  data.params.map(function (i) {
                    i.picfileList = [i.icon];
                  });
                  _this.form = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e, item, index) {
      this.form.params[index].picfileList = e;
      this.form.params[index].icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    langContentChange: function langContentChange() {
      var _this2 = this;

      var list = _toConsumableArray(this.form.params);

      this.form.params = [];
      this.form.language.forEach(function (item) {
        var langData = _this2.languageLists.find(function (i) {
          return i.sign == item;
        });

        var index = list.findIndex(function (i) {
          return i.language == item;
        });

        _this2.form.params.push(index > -1 ? list[index] : {
          language: langData.sign,
          picfileList: [],
          icon: '',
          game_name: '',
          languageName: langData.name
        });
      });
    },
    addContent: function addContent() {
      console.log(this.form.extend);
      this.form.extend.push({
        label: "",
        value: ""
      });
    },
    addLoginContent: function addLoginContent() {
      this.form.login_type_list.push({
        value: ""
      });
    },
    removeLoginContent: function removeLoginContent(item) {
      var index = this.form.login_type_list.indexOf(item);

      if (index !== -1) {
        this.form.login_type_list.splice(index, 1);
      }
    },
    removeContent: function removeContent(item) {
      var index = this.form.extend.indexOf(item);

      if (index !== -1) {
        this.form.extend.splice(index, 1);
      }
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = _objectSpread(_objectSpread({}, this.copyform), {}, {
        extend: [],
        login_type_list: [],
        id: type ? this.form.id : ""
      });
      this.picfileList = [];
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this3.form));
          data.params.map(function (i) {
            i.picfileList = i.picfileList.map(function (j) {
              return j.response ? j.response.data : j.url;
            });
          });
          var d = {};
          data.extend.forEach(function (item, index) {
            d[item.label] = item.value;
          });
          data.extend = JSON.stringify(d);
          data.params = JSON.stringify(data.params);
          data.language = data.language.toString();
          data.login_type_list = data.login_type_list.map(function (i) {
            return i.value;
          }).toString();
          var reqFn = data.id ? 'paymentGamesUpdate' : 'paymentGamesAdd';

          _this3.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('change');
            }
          });
        }
      });
    }
  }
};